
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5X218", function(module, exports) {

$parcel$export(module.exports, "imageMap", () => $4554070dd500beb6$export$c66125bb69fe918a);

































































const $4554070dd500beb6$export$c66125bb69fe918a = {
    'Anna.jpg': new URL((parcelRequire("4SmZI"))),
    'Blaire.jpg': new URL((parcelRequire("9Utqa"))),
    'Duke.jpg': new URL((parcelRequire("6CF5D"))),
    'Ella.jpg': new URL((parcelRequire("lffte"))),
    'Jane.jpg': new URL((parcelRequire("8FwcY"))),
    'Kelly.jpg': new URL((parcelRequire("kGLoe"))),
    'Kikang.jpg': new URL((parcelRequire("8f3St"))),
    'Kun.jpg': new URL((parcelRequire("1FY2W"))),
    'Rachel.jpg': new URL((parcelRequire("kFoIj"))),
    'Sehyun.jpg': new URL((parcelRequire("8IM8n"))),
    'Taegyun.jpg': new URL((parcelRequire("lm2Xa"))),
    'Yony.jpg': new URL((parcelRequire("3O7T6"))),
    'aiden.jpg': new URL((parcelRequire("5y4XK"))),
    'alice.jpg': new URL((parcelRequire("1vWv5"))),
    'byun-og.jpg': new URL((parcelRequire("iesKV"))),
    'byun.jpg': new URL((parcelRequire("gEVPa"))),
    'christine.jpg': new URL((parcelRequire("eiZeT"))),
    'dongmin.png': new URL((parcelRequire("iZ8fB"))),
    'elena.png': new URL((parcelRequire("jW3df"))),
    'ellie.jpg': new URL((parcelRequire("cpq0n"))),
    'hyojung.jpg': new URL((parcelRequire("lE28R"))),
    'ina.jpg': new URL((parcelRequire("byDmL"))),
    'jason.jpg': new URL((parcelRequire("8XX00"))),
    'jingee.jpg': new URL((parcelRequire("gZauI"))),
    'john.jpg': new URL((parcelRequire("bwhk3"))),
    'jy-og.jpg': new URL((parcelRequire("j91Da"))),
    'jy.jpg': new URL((parcelRequire("6eoDR"))),
    'kevin.jpg': new URL((parcelRequire("ciE5A"))),
    'kijun-og.jpg': new URL((parcelRequire("3ETsY"))),
    'kijun.jpg': new URL((parcelRequire("7J6bd"))),
    'minhong.jpg': new URL((parcelRequire("lQOXG"))),
    'sarah.jpg': new URL((parcelRequire("amQOb"))),
    'scott.jpg': new URL((parcelRequire("3lu6R"))),
    'suhjin.jpg': new URL((parcelRequire("7K4rp"))),
    'sunny.jpg': new URL((parcelRequire("dYhZE"))),
    'ted.jpg': new URL((parcelRequire("6tGhm"))),
    'youngjoong.png': new URL((parcelRequire("jwiT8"))),
    '2.06.jpg': new URL((parcelRequire("2nxQq"))),
    '3sigma1.gif': new URL((parcelRequire("ck7fP"))),
    'aura.png': new URL((parcelRequire("lgf6c"))),
    'char.png': new URL((parcelRequire("5bwl3"))),
    'cmu-play.png': new URL((parcelRequire("9h66g"))),
    'cubs4.png': new URL((parcelRequire("cfnab"))),
    'dokdo.png': new URL((parcelRequire("b1p70"))),
    'eco8-2.jpg': new URL((parcelRequire("dS4YW"))),
    'gpt.png': new URL((parcelRequire("7zelG"))),
    'horizon.png': new URL((parcelRequire("lNUGg"))),
    'meta2.png': new URL((parcelRequire("jILxo"))),
    'meta_1.jpg': new URL((parcelRequire("8TyYF"))),
    'mu_1.png': new URL((parcelRequire("iwEDd"))),
    'mu_2.png': new URL((parcelRequire("3SQQv"))),
    'mun.png': new URL((parcelRequire("hABkM"))),
    'nft.webp': new URL((parcelRequire("kWgeP"))),
    'nft3.png': new URL((parcelRequire("ipguj"))),
    'resq.png': new URL((parcelRequire("fRyYj"))),
    'revision.png': new URL((parcelRequire("5vpvK"))),
    'unison.png': new URL((parcelRequire("80GWC"))),
    'xr.png': new URL((parcelRequire("eJFnH"))),
    'zeta3.png': new URL((parcelRequire("6FcDR"))),
    'bridgelab.png': new URL((parcelRequire("gMhi1"))),
    'cherry.jpg': new URL((parcelRequire("beB20"))),
    'chris.jpg': new URL((parcelRequire("9MASs"))),
    'mangotango.png': new URL((parcelRequire("du4NB"))),
    'techno24.png': new URL((parcelRequire("6oQI7"))),
    'techno25.jpg': new URL((parcelRequire("91odg")))
};

});
parcelRegister("4SmZI", function(module, exports) {
module.exports = import.meta.resolve("f7ALq");

});

parcelRegister("9Utqa", function(module, exports) {
module.exports = import.meta.resolve("5HE42");

});

parcelRegister("6CF5D", function(module, exports) {
module.exports = import.meta.resolve("4yHRa");

});

parcelRegister("lffte", function(module, exports) {
module.exports = import.meta.resolve("b3kXl");

});

parcelRegister("8FwcY", function(module, exports) {
module.exports = import.meta.resolve("2gUIX");

});

parcelRegister("kGLoe", function(module, exports) {
module.exports = import.meta.resolve("1VoKD");

});

parcelRegister("8f3St", function(module, exports) {
module.exports = import.meta.resolve("kHTsx");

});

parcelRegister("1FY2W", function(module, exports) {
module.exports = import.meta.resolve("aewHu");

});

parcelRegister("kFoIj", function(module, exports) {
module.exports = import.meta.resolve("3YzX7");

});

parcelRegister("8IM8n", function(module, exports) {
module.exports = import.meta.resolve("iNLAu");

});

parcelRegister("lm2Xa", function(module, exports) {
module.exports = import.meta.resolve("4nG25");

});

parcelRegister("3O7T6", function(module, exports) {
module.exports = import.meta.resolve("gpFGB");

});

parcelRegister("5y4XK", function(module, exports) {
module.exports = import.meta.resolve("cnD2P");

});

parcelRegister("1vWv5", function(module, exports) {
module.exports = import.meta.resolve("51TFV");

});

parcelRegister("iesKV", function(module, exports) {
module.exports = import.meta.resolve("gIMyE");

});

parcelRegister("gEVPa", function(module, exports) {
module.exports = import.meta.resolve("FRj2v");

});

parcelRegister("eiZeT", function(module, exports) {
module.exports = import.meta.resolve("9HtJ5");

});

parcelRegister("iZ8fB", function(module, exports) {
module.exports = import.meta.resolve("s1yjQ");

});

parcelRegister("jW3df", function(module, exports) {
module.exports = import.meta.resolve("9Ic7p");

});

parcelRegister("cpq0n", function(module, exports) {
module.exports = import.meta.resolve("bhuzd");

});

parcelRegister("lE28R", function(module, exports) {
module.exports = import.meta.resolve("22eyJ");

});

parcelRegister("byDmL", function(module, exports) {
module.exports = import.meta.resolve("81S2C");

});

parcelRegister("8XX00", function(module, exports) {
module.exports = import.meta.resolve("aZ8Lw");

});

parcelRegister("gZauI", function(module, exports) {
module.exports = import.meta.resolve("hiMIZ");

});

parcelRegister("bwhk3", function(module, exports) {
module.exports = import.meta.resolve("hjbXU");

});

parcelRegister("j91Da", function(module, exports) {
module.exports = import.meta.resolve("jY2WI");

});

parcelRegister("6eoDR", function(module, exports) {
module.exports = import.meta.resolve("jFNHR");

});

parcelRegister("ciE5A", function(module, exports) {
module.exports = import.meta.resolve("2kkfl");

});

parcelRegister("3ETsY", function(module, exports) {
module.exports = import.meta.resolve("gGIsn");

});

parcelRegister("7J6bd", function(module, exports) {
module.exports = import.meta.resolve("iiIja");

});

parcelRegister("lQOXG", function(module, exports) {
module.exports = import.meta.resolve("gqSQA");

});

parcelRegister("amQOb", function(module, exports) {
module.exports = import.meta.resolve("2GSzT");

});

parcelRegister("3lu6R", function(module, exports) {
module.exports = import.meta.resolve("7aXXL");

});

parcelRegister("7K4rp", function(module, exports) {
module.exports = import.meta.resolve("qE5XC");

});

parcelRegister("dYhZE", function(module, exports) {
module.exports = import.meta.resolve("cp3Rn");

});

parcelRegister("6tGhm", function(module, exports) {
module.exports = import.meta.resolve("fOBHI");

});

parcelRegister("jwiT8", function(module, exports) {
module.exports = import.meta.resolve("gbkrz");

});

parcelRegister("2nxQq", function(module, exports) {
module.exports = import.meta.resolve("gksOW");

});

parcelRegister("ck7fP", function(module, exports) {
module.exports = import.meta.resolve("a2m6h");

});

parcelRegister("lgf6c", function(module, exports) {
module.exports = import.meta.resolve("azBml");

});

parcelRegister("5bwl3", function(module, exports) {
module.exports = import.meta.resolve("dlKr4");

});

parcelRegister("9h66g", function(module, exports) {
module.exports = import.meta.resolve("1CzlQ");

});

parcelRegister("cfnab", function(module, exports) {
module.exports = import.meta.resolve("cjoEC");

});

parcelRegister("b1p70", function(module, exports) {
module.exports = import.meta.resolve("eMnDV");

});

parcelRegister("dS4YW", function(module, exports) {
module.exports = import.meta.resolve("h93bc");

});

parcelRegister("7zelG", function(module, exports) {
module.exports = import.meta.resolve("6Itgm");

});

parcelRegister("lNUGg", function(module, exports) {
module.exports = import.meta.resolve("5PxAD");

});

parcelRegister("jILxo", function(module, exports) {
module.exports = import.meta.resolve("6DvZW");

});

parcelRegister("8TyYF", function(module, exports) {
module.exports = import.meta.resolve("bZVZt");

});

parcelRegister("iwEDd", function(module, exports) {
module.exports = import.meta.resolve("1D9Zz");

});

parcelRegister("3SQQv", function(module, exports) {
module.exports = import.meta.resolve("dBsao");

});

parcelRegister("hABkM", function(module, exports) {
module.exports = import.meta.resolve("eFz4I");

});

parcelRegister("kWgeP", function(module, exports) {
module.exports = import.meta.resolve("iVC1f");

});

parcelRegister("ipguj", function(module, exports) {
module.exports = import.meta.resolve("hrquO");

});

parcelRegister("fRyYj", function(module, exports) {
module.exports = import.meta.resolve("duplA");

});

parcelRegister("5vpvK", function(module, exports) {
module.exports = import.meta.resolve("lH0pa");

});

parcelRegister("80GWC", function(module, exports) {
module.exports = import.meta.resolve("kKoPK");

});

parcelRegister("eJFnH", function(module, exports) {
module.exports = import.meta.resolve("e0Msu");

});

parcelRegister("6FcDR", function(module, exports) {
module.exports = import.meta.resolve("aK4ow");

});

parcelRegister("gMhi1", function(module, exports) {
module.exports = import.meta.resolve("txpUI");

});

parcelRegister("beB20", function(module, exports) {
module.exports = import.meta.resolve("8x2uz");

});

parcelRegister("9MASs", function(module, exports) {
module.exports = import.meta.resolve("16t2w");

});

parcelRegister("du4NB", function(module, exports) {
module.exports = import.meta.resolve("kGV8t");

});

parcelRegister("6oQI7", function(module, exports) {
module.exports = import.meta.resolve("csCZH");

});

parcelRegister("91odg", function(module, exports) {
module.exports = import.meta.resolve("bUgad");

});


var $72a2798423e22a74$exports = {};
$72a2798423e22a74$exports = JSON.parse('[{"category":"staff","name":"Ella","school":"","position":"Director","field":[],"image":"Ella.jpg","isMain":false},{"category":"staff","name":"Sarah","school":"","position":"Lead Project Manager","field":[],"image":"sarah.jpg","isMain":false},{"category":"staff","name":"Yony","school":"","position":"Project Manager","field":[],"image":"Yony.jpg","isMain":false},{"category":"staff","name":"Young Joong","school":"","position":"Project Manager","field":[],"image":"youngjoong.png","isMain":false},{"category":"staff","name":"Duke","school":"","position":"Education Manager","field":[],"image":"Duke.jpg","isMain":false},{"category":"instructor","name":"Aiden","school":"\uC11C\uC6B8\uB300\uD559\uAD50","position":"","field":["\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4"],"image":"aiden.jpg","isMain":false},{"category":"instructor","name":"Alice","school":"\uC11C\uC6B8\uB300\uD559\uAD50","position":"","field":["AI/ML","\uC54C\uACE0\uB9AC\uC998"],"image":"alice.jpg","isMain":false},{"category":"instructor","name":"Blaire","school":"Georgie Institute of Technology","position":"","field":["\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4","\uC54C\uACE0\uB9AC\uC998","UI/UX","CAE"],"image":"Blaire.jpg","isMain":false},{"category":"instructor","name":"Dongmin","school":"\uC5F0\uC138\uB300\uD559\uAD50","position":"","field":["\uB85C\uBCF4\uD2F1\uC2A4"],"image":"dongmin.png","isMain":false},{"category":"instructor","name":"Ellie","school":"UC Berkeley","position":"","field":["\uD50C\uC2A4\uD0DD \uAC1C\uBC1C","\uC54C\uACE0\uB9AC\uC998","\uBE14\uB85D\uCCB4\uC778"],"image":"ellie.jpg","isMain":false},{"category":"instructor","name":"Ina","school":"\uC11C\uC6B8\uB300\uD559\uAD50","position":"","field":["UI/UX","\uB85C\uBCF4\uD2F1\uC2A4"],"image":"ina.jpg","isMain":false},{"category":"instructor","name":"Jason","school":"Columbia University","position":"","field":["\uBA38\uC2E0\uB7EC\uB2DD","\uB525\uB7EC\uB2DD","AI"],"image":"jason.jpg","isMain":false},{"category":"instructor","name":"Jingee","school":"HKUST (\uD64D\uCF69\uACFC\uAE30\uB300)","position":"","field":["\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4","\uBA38\uC2E0 \uB7EC\uB2DD","\uAC8C\uC784 \uAC1C\uBC1C"],"image":"jingee.jpg","isMain":false},{"category":"instructor","name":"JY","school":"Carnegie Mellon University","position":"","field":["\uC54C\uACE0\uB9AC\uC998","\uD480\uC2A4\uD0DD \uAC1C\uBC1C","UI/UX"],"image":"jy.jpg","isMain":true},{"category":"instructor","name":"Kevin","school":"Georgia Institute of Technology","position":"","field":["\uC571 \uAC1C\uBC1C","\uC54C\uACE0\uB9AC\uC998"],"image":"kevin.jpg","isMain":false},{"category":"instructor","name":"Kijun","school":"HKUST (\uD64D\uCF69 \uACFC\uAE30\uB300)","position":"","field":["\uC54C\uACE0\uB9AC\uC998","\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4"],"image":"kijun.jpg","isMain":true},{"category":"instructor","name":"Kikang","school":"\uC11C\uC6B8\uACFC\uD559\uAE30\uC220\uB300\uD559\uAD50","position":"","field":["\uB85C\uBCF4\uD2F1\uC2A4"],"image":"Kikang.jpg","isMain":false},{"category":"instructor","name":"Kun","school":"\uC11C\uAC15\uB300\uD559\uAD50","position":"","field":["Data Science","AI/ML","Programming"],"image":"Kun.jpg","isMain":false},{"category":"instructor","name":"Minhong","school":"\uAC74\uAD6D\uB300 \uAE30\uACC4\uC124\uACC4\uD559\uACFC \uC11D\uC0AC","position":"","field":["\uC784\uBCA0\uB514\uB4DC \uC18C\uD504\uD2B8\uC6E8\uC5B4"],"image":"minhong.jpg","isMain":false},{"category":"instructor","name":"Scott","school":"University of Rochester, \uC5F0\uC138\uB300\uD559\uAD50 \uC11D\uC0AC(CS)","position":"","field":["\uC6F9 \uAC1C\uBC1C","\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4","\uC54C\uACE0\uB9AC\uC998"],"image":"scott.jpg","isMain":false},{"category":"instructor","name":"Sehyoun","school":"Lehigh University","position":"","field":["\uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4","\uC54C\uACE0\uB9AC\uC998","\uBC31\uC5D4\uB4DC \uAC1C\uBC1C"],"image":"Sehyun.jpg","isMain":false},{"category":"instructor","name":"Sunny","school":"New York University","position":"","field":["\uD480\uC2A4\uD0DD \uAC1C\uBC1C","\uC54C\uACE0\uB9AC\uC998"],"image":"sunny.jpg","isMain":false},{"category":"instructor","name":"Ted","school":"Georgie Institute of Technology","position":"","field":["\uC54C\uACE0\uB9AC\uC998","\uC571 \uAC1C\uBC1C"],"image":"ted.jpg","isMain":false}]');



var $5X218 = parcelRequire("5X218");
var $c30c6651c4c506e0$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $c30c6651c4c506e0$exports = t();
})($c30c6651c4c506e0$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


const $ea5fa22f465921cc$var$newsSpreadsheetCsvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTZu4wuPozYwq6QAiuqcGixw3JOr4Pw0s0qpWxJf57WPHuOb5sFiytP2tHGWZdLdztrYY8mxOZc8m0Z/pub?gid=0&single=true&output=csv';
function $ea5fa22f465921cc$var$parseCsv(csv) {
    const { data: data } = (0, $c30c6651c4c506e0$exports.parse)(csv, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header)=>header.trim(),
        transform: (value)=>value.trim()
    });
    const news = data.map((item)=>({
            ...item,
            tags: item.tags ? item.tags.split(',').map((tag)=>tag.trim()) : []
        })).sort((a, b)=>new Date(b.date) - new Date(a.date));
    return news;
}
async function $ea5fa22f465921cc$export$cadad47cc1e7eb14() {
    return fetch($ea5fa22f465921cc$var$newsSpreadsheetCsvUrl).then((res)=>res.text()).then((csvText)=>{
        const news = $ea5fa22f465921cc$var$parseCsv(csvText).sort((a, b)=>new Date(b.date) - new Date(a.date));
        const newsHtml = news.map((item)=>`
      <tr
        data-href=${item.href}
        class="hover-transition cursor-pointer border-b border-neutral-300/60 even:bg-zinc-50 odd:bg-white hover:bg-neutral-200/20">
        <td class="px-4 py-3 text-xs sm:text-sm text-nowrap w-24 sm:w-[100px]">${item.date}</td>
        <th scope="row" class="px-4 py-3 font-medium truncate max-w-[10rem] text-sm sm:text-base sm:max-w-none">
          ${item.title}
        </th>
        <td class="hidden sm:flex justify-end gap-2 px-4 py-3">
          ${item.tags.map((tag)=>`
            <span
              class="break-keep rounded-full bg-neutral-200/70 px-4 py-2 text-xs font-medium uppercase outline outline-neutral-300/80">
              ${tag}
            </span>
            `).join('')}
        </td>
      </tr>
    `).join('');
        return newsHtml;
    }).catch((err)=>{
        console.error('Failed to load news from Google Sheets:', err);
    });
}


const $f12278347681fff4$var$$instructorsList = document.getElementById('instructors-list');
const $f12278347681fff4$var$$mentorsList = document.getElementById('mentors-list');
const $f12278347681fff4$var$$staffList = document.getElementById('staff-list');
const $f12278347681fff4$var$$newsList = document.getElementById('news-list');
const $f12278347681fff4$var$instructors = (0, (/*@__PURE__*/$parcel$interopDefault($72a2798423e22a74$exports))).filter((item)=>item.category === 'instructor');
const $f12278347681fff4$var$mentors = (0, (/*@__PURE__*/$parcel$interopDefault($72a2798423e22a74$exports))).filter((item)=>item.category === 'mentor');
const $f12278347681fff4$var$staff = (0, (/*@__PURE__*/$parcel$interopDefault($72a2798423e22a74$exports))).filter((item)=>item.category === 'staff');
var $eeed08a37be00009$exports = {};
$eeed08a37be00009$exports = import.meta.resolve("4Yogz");


const $f12278347681fff4$var$instructorsHtml = $f12278347681fff4$var$instructors.filter((item)=>!item.isMain).map((item)=>`
  <div class="bg-zinc-50 shadow-lg overflow-hidden rounded-xs">
    <img
      src="${(0, $5X218.imageMap)[item.image] || new URL($eeed08a37be00009$exports)}"
      alt="${item.name}"
      draggable="false"
      class="aspect-square w-full object-cover object-top" />
    <div class="flex flex-col gap-2 p-4 text-sm">
      <p class="text-base font-medium">${item.name}</p>
      <p>${item.field.join(', ')}</p>
      <p>${item.school}</p>
    </div>
  </div>
`).join('');
if ($f12278347681fff4$var$$instructorsList) $f12278347681fff4$var$$instructorsList.innerHTML = $f12278347681fff4$var$instructorsHtml;

const $f12278347681fff4$var$mentorsHtml = $f12278347681fff4$var$mentors.map((item)=>`
  <div class="bg-zinc-50 shadow-lg overflow-hidden rounded-xs">
    <img
      src="${(0, $5X218.imageMap)[item.image] || new URL($eeed08a37be00009$exports)}"
      alt="${item.name}"
      draggable="false"
      class="aspect-square w-full" />
    <div class="flex flex-col gap-2 p-4 text-sm">
      <p class="text-base font-medium">${item.name}</p>
      <p>${item.field.join()}</p>
      <p class="font-medium">${item.employment}</p>
      <p>${item.school}</p>
    </div>
  </div>
`).join('');
if ($f12278347681fff4$var$$mentorsList) $f12278347681fff4$var$$mentorsList.innerHTML = $f12278347681fff4$var$mentorsHtml;

const $f12278347681fff4$var$staffHtml = $f12278347681fff4$var$staff.map((item)=>`
  <div class="bg-zinc-50 shadow-lg overflow-hidden rounded-xs">
    <img
      src="${(0, $5X218.imageMap)[item.image] || new URL($eeed08a37be00009$exports)}"
      alt="${item.name}"
      draggable="false"
      class="aspect-square w-full" />
    <div class="flex flex-col gap-2 p-4 text-sm">
      <p class="text-base font-medium">${item.name}</p>
      <p>${item.position}</p>
    </div>
  </div>
`).join('');
if ($f12278347681fff4$var$$staffList) $f12278347681fff4$var$$staffList.innerHTML = $f12278347681fff4$var$staffHtml;
if ($f12278347681fff4$var$$newsList) (0, $ea5fa22f465921cc$export$cadad47cc1e7eb14)().then((newsHtml)=>{
    $f12278347681fff4$var$$newsList.innerHTML = newsHtml;
    $f12278347681fff4$var$$newsList.addEventListener('click', (event)=>{
        const $tr = event.target.closest('tr[data-href]');
        if ($tr) {
            const url = $tr.getAttribute('data-href');
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    });
});


//# sourceMappingURL=about.f29cbe6d.js.map
